<template>
  <div id="txtContainer" ref="txtContainer">
    <loading v-show="loadingActive"></loading>
    <iframe :src="urlSrc"></iframe>
    <div style="z-index:99999" class="returnfsty" @click="returnf">
      <p id="goBack">返回</p>
    </div>
  </div>
</template>

<script>
import { scanUrlapp } from "@/CommonDP/utils";
import loading from "@/CommonDP/components/loading/loading.vue";
export default {
  components: {
    loading
  },
  data() {
    return {
      loadingActive: true,
      urlSrc: ""
    };
  },

  async mounted() {
    const { f, n } = this.$route.query;
    document.title = n;
    this.urlSrc = scanUrlapp(f);
    this.loadingActive = false;
  },

  methods: {
    returnf() {
      // do sth
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#txtContainer {
  width: 100%;
  height: 100%;

  iframe {
    width: 100%;
    height: 100%;
  }

  .returnfsty {
    line-height: 48px;
    height: 48px;
    text-align: center;
    background: #fff;
    font-size: 16px;
    color: #616161;
    cursor: pointer;
    position: absolute;
    z-index: 9;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
